export default {"src":"/_next/static/media/icon_play_tungsten_friends.dbe0914e.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};